export default (axios, path = '/user/account') => ({
  changePassword: async ({ password, confirmPassword } = {}) => {
    return await axios.put(`${path}/change-password`, {
      password,
      confirmPassword,
    })
  },
  changePasswordReset: async ({ password, confirmPassword, passwordResetToken } = {}) => {
    return await axios.put(`${path}/change-password`, {
      password,
      confirmPassword,
      passwordResetToken
    })
  },
  forgotPassword: async (email) => {
    return await axios.post(`${path}/forgot-password`, email, {headers: {"Content-Type": "text/plain"}})
  },
  findAllHistory: async () => {
    return await axios.get(`${path}/history`)
  },
  findHistoryById: async ({ historyId }) => {
    return await axios.get(`${path}/history`, { historyId })
  },
  me: async (simple = true) => {
    return await axios.get(`${path}/me?simple=${simple}`)
  },
  meForArchived: async (archivedId) => {
    return await axios.get(`${path}/me?archivedGameId=${archivedId}&simple=false`)
  },
  register: async ({ email, username, password, confirmPassword } = {}) => {
    return await axios.post(`${path}/register`, {
      email,
      username,
      password,
      confirmPassword,
    })
  },
  verifyRegistration: async (token) => {
    return await axios.post(`${path}/register/verify?token=${token}`)
  },
  async leaveGame() {
    await axios.put(`${path}/run-away`)
  },
})
